import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';
import { GlobalFacade } from '~app/app/~store/facades/global.facade';
import { Observable, from, mergeMap, of } from 'rxjs';

export const NON_AUTHENTICATED_GUARD = ():
  | Observable<UrlTree | boolean>
  | boolean => {
  const authFacade = inject(AuthFacade);
  const globalFacade = inject(GlobalFacade);
  const router = inject(Router);
  return authFacade.accessToken$.pipe(
    mergeMap(accessToken => {
      if (accessToken) {
        const currentUrl = globalFacade.routeData?.currentUrl;
        return from(router.navigateByUrl(currentUrl || '/'));
      }
      return of(true);
    })
  );
};
